export { default } from "./Variation-component";
